import { type FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { sendReset } from "../lib/auth-actions";
import { normalizeEmail, validateEmail } from "../lib/validators";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    const err = validateEmail(email);
    if (err) {
      setError(err);
      return;
    }
    setError(null);
    try {
      await sendReset(email);
      setSent(true);
    } catch (err2) {
      setError(err2 instanceof Error ? err2.message : "전송에 실패했습니다");
    }
  }

  return (
    <div className="mx-auto mt-16 w-full max-w-sm fade-up">
      <div className="glass neon-border rounded-2xl p-7">
        <h1 className="neon-text text-xl font-bold">비밀번호 찾기</h1>
        {sent ? (
          <p className="mt-4 text-sm text-slate-300">
            {email}로 재설정 메일을 보냈습니다. 메일함을 확인해주세요.
          </p>
        ) : (
          <form className="mt-4 flex flex-col gap-3" onSubmit={onSubmit} noValidate>
            <input
              type="email"
              placeholder="이메일"
              value={email}
              onChange={(e) => setEmail(normalizeEmail(e.target.value))}
              className="input-cyber rounded-lg px-3 py-2.5"
            />
            {error && <p className="text-sm text-fuchsia-400">{error}</p>}
            <button type="submit" className="btn-neon rounded-lg py-2.5 font-semibold">
              재설정 메일 보내기
            </button>
          </form>
        )}
        <p className="mt-4 text-center text-xs text-slate-500">
          <Link to="/login" className="transition hover:text-cyan-300">
            로그인으로 돌아가기
          </Link>
        </p>
      </div>
    </div>
  );
}
